"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.listenForOAuthFlowCancellation = void 0;
const listenForOAuthFlowCancellation = () => {
    // no-op for non-browser environments
};
exports.listenForOAuthFlowCancellation = listenForOAuthFlowCancellation;
